// extracted by mini-css-extract-plugin
module.exports = {"tab_link":"Tab_tab_link__R2uTt","is_active":"Tab_is_active__X1_14"};